/** @fileoverview Constants of the student Tasks Tracker (AR-898). */

/** Query param that keeps the selected project in the URL of the standalone page. */
export const PARAM_PROJECT = 'project'

/** Route of the standalone page (also used by the "My tasks" link and the sidebar). */
export const STUDENT_TASK_TRACKER_PATH = '/app/student-task-tracker'

/** Width of the project selector on the standalone page (same as the teacher's filters). */
export const PROJECT_SELECT_WIDTH = 320

/** The student has at most a handful of projects; one page is enough for the selector. */
export const PROJECTS_PAGE_LIMIT = 100

/** Prototype: status columns are 200px wide; the lesson column takes the rest. */
export const STATUS_COLUMN_WIDTH = 200

/** Breakpoint under which the table becomes a list of cards. */
export const MOBILE_BREAKPOINT = '(max-width: 768px)'

/** Backend `Project#status` of a project the teacher has closed (cells become read-only). */
export const FINISHED_PROJECT_STATUS = 'finished'

/** Returns today's date as `YYYY-MM-DD`, the format the API uses for lesson dates. */
export function todayIsoDate(): string {
  return new Date().toISOString().slice(0, 10)
}
